import {
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Checkbox,
  Button,
} from "@material-tailwind/react";
import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import { loginController } from "./LoginController";
import { alertController } from "../../../../Controllers/AlertController";
import { loginSignupController } from "../LoginSignupController";
import { ResetPasswordDialog } from "../../../ResetPasswordDialog";

type LoginCardProps = {
  visible: boolean
}

export const LoginCard = observer(({ visible }: LoginCardProps) => {
  const [resetDialogOpen, setResetDialogOpen] = useState(false);

  const login = async () => {
    const loginSuccessful = await loginController.login()
    if (!loginSuccessful) {
      alertController.displayAlert(
        "Credentials incorrect",
        "Either username or password are incorrect, please try again",
        "error",
        4000
      )
      return;
    }
  }

  const handleCloseClick = () => {
    loginSignupController.setLoginSignupWindowVisible(false)
  }

  return (
    visible &&
    <>
      <CardHeader
        variant="gradient"
        color="gray"
        className="mx-0 mdh:mx-4 mt-0 mdh:-mt-6 mdh:mb-4 rounded-none mdh:rounded-xl grid h-36 place-items-center"
      >
        <Typography
          variant="h3"
          color="white"
          className="text-center text-xl mdh:text-3xl px-4 mdh:px-6"
        >
          Open your magazine reseller account
        </Typography>
      </CardHeader>
      <CardBody className="flex flex-col gap-4">
        <Input label="Email" size="lg" value={loginController.username}
          onChange={e => loginController.setLogin(e.target.value)} />
        <Input label="Password" size="lg" type={"password"} value={loginController.password}
          onChange={e => loginController.setPassword(e.target.value)} />
        <Typography
          as="button"
          variant="small"
          color="blue"
          className="hover:underline hover:text-blue-800 transition text-right"
          onClick={() => setResetDialogOpen(true)}
        >
          Forgot password?
        </Typography>
        <div className="-ml-2.5">
          <Checkbox label="Remember Me" onClick={() => loginController.setRememberMe(!loginController.rememberUser)} />
        </div>
      </CardBody>
      <CardFooter className="pt-0">
        <div className="flex items-center justify-center mb-3">
          <div className="h-[1px] w-[40%] bg-gray-300"></div>
        </div>
        <div className="flex flex-col gap-2">
          <Button variant="gradient" fullWidth onClick={login}
            disabled={!loginController.username || !loginController.password}>
            Sign In
          </Button>
          <Button variant="outlined" fullWidth onClick={handleCloseClick}>
            Close
          </Button>
        </div>
        <Typography variant="small" className="mt-6 flex justify-center">
          Open a magazine reseller account
          <Typography
            as={"button"}
            onClick={loginController.goToSignup}
            variant="small"
            color="blue-gray"
            className="ml-1 font-bold"
          >
            HERE
          </Typography>
        </Typography>
      </CardFooter>

      <ResetPasswordDialog
        open={resetDialogOpen}
        onClose={() => setResetDialogOpen(false)}
      />
    </>
  );
})
